import type { ReactElement } from "react";
import * as React from "react";

export default function ReclameAquiIcon(props: React.SVGProps<any>): ReactElement {
  return (
    <svg width="1em" height="1em" viewBox="0 0 380 328" {...props}>
      <g fill="none">
        <path
          fill="#056734"
          d="M254.299.006c-4.3-.1-6.2 1-7.7 5.3-35 100.1-70.2 200.2-105.3 300.3-2.4 7-4.799 14-7.299 21.4 27.9 0 55-.2 82.2.1 5.4.1 7.7-1.4 9-6.8 3.3-13.8 7.4-27.5 11.2-41h54.1v47.3h89.299c-9.4-109-18.799-217.5-28.299-326.6-2.5 0-4.401 0-6.201.1-30.3 0-60.7.1-91-.1zm32.601 95.7c.3 0 .599.001.899.1.8 38.7 1.6 77.4 2.3 116.5h-35.8c10.9-39.2 21.801-77.9 32.601-116.6z"
        />
        <path
          fill="#94C120"
          d="M100.299 1.008c-17.325.025-34.65.1-52 .1h-5.2C28.7 110.208 14.4 218.808 0 327.808h91.398c5.4-40.7 10.802-81.3 16.202-121.9h1.1c7.9 40.5 15.798 81 23.698 121.7h96.9c-15.2-48.3-30.3-96.2-45.4-144.4 1.8-.9 3.3-1.6 4.9-2.1 18.5-8.7 34.7-20.3 46-37.8 12.6-19.6 16.8-41.4 15.6-64.3-1.3-24.5-11.4-44.5-31.5-59-19.9-14.3-42.8-18.6-66.6-18.8-17.35-.2-34.674-.225-52-.2zm31.619 68.158c14.343.156 24.043 10.054 24.48 25.541.3 12.3-1.098 24.202-7.298 35.102-.618 1.055-1.328 2.056-2.08 3.031-.38.491-.77.974-1.18 1.443-7.231 8.489-19.455 13.342-30.442 11.625 3.3-25.5 6.7-50.9 10-76.2a37.944 37.944 0 0 1 2.122-.29 34.088 34.088 0 0 1 4.398-.252z"
        />
      </g>
    </svg>
  );
}
